import { render, staticRenderFns } from "./HistoryHomework.vue?vue&type=template&id=2bc0859f&scoped=true"
import script from "./HistoryHomework.vue?vue&type=script&lang=js"
export * from "./HistoryHomework.vue?vue&type=script&lang=js"
import style0 from "./HistoryHomework.vue?vue&type=style&index=0&id=2bc0859f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc0859f",
  null
  
)

export default component.exports